import type {
    OnboardingPropertyCategoryPagePropertyOnboardingContextFieldsV1,
    OnboardingPropertyCategoryPagePropertyOnboardingContextIdsV1,
} from "@agoda/analytics-messages-definition-property-onboarding/contexts.split";
import {
    BackElementPropertyOnboardingManifestV1,
    NextElementPropertyOnboardingManifestV1,
    PropertyCategoryHomeCardElementPropertyOnboardingManifestV1,
    PropertyCategoryHotelCardElementPropertyOnboardingManifestV1,
    PropertyCategoryUniqueCardElementPropertyOnboardingManifestV1,
    SelectLanguageElementPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/elements";
import {
    OnboardingPropertyCategoryPagePropertyOnboardingContextManifestV1,
    WebOnboardingPropertyCategoryVisitEventPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/onboarding-property-category-page";
import { BaseContextFieldsMapping } from "../../functions/appContext";
import { defineBinder } from "../../functions/defineBinder";

export const propertyCategoryBinder = defineBinder(({ webAnalytics, action: { hover, click, reveal } }) => {
    webAnalytics.pageContext<
        OnboardingPropertyCategoryPagePropertyOnboardingContextIdsV1,
        OnboardingPropertyCategoryPagePropertyOnboardingContextFieldsV1
    >(OnboardingPropertyCategoryPagePropertyOnboardingContextManifestV1.ids, {
        auth_user_id: BaseContextFieldsMapping.auth_user_id,
        member_id: BaseContextFieldsMapping.member_id,
        property_id: BaseContextFieldsMapping.property_id,
        is_internal_user: BaseContextFieldsMapping.is_internal_user,
    });

    webAnalytics.observe(WebOnboardingPropertyCategoryVisitEventPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], SelectLanguageElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement(
        [hover, click, reveal],
        PropertyCategoryHomeCardElementPropertyOnboardingManifestV1.ids,
        {},
    );

    webAnalytics.observeElement(
        [hover, click, reveal],
        PropertyCategoryHotelCardElementPropertyOnboardingManifestV1.ids,
        {},
    );

    webAnalytics.observeElement(
        [hover, click, reveal],
        PropertyCategoryUniqueCardElementPropertyOnboardingManifestV1.ids,
        {},
    );

    webAnalytics.observeElement([click], BackElementPropertyOnboardingManifestV1.ids, {});

    webAnalytics.observeElement([click], NextElementPropertyOnboardingManifestV1.ids, {});
});
